const isPro = Object.is(process.env.NODE_ENV, 'production')

module.exports = {
    // baseUrl: isPro ? 'http://api.beta.shanghunbao.com/api/v2/':'api/'
    baseUrl: 'http://api.shanghunbao.com/api/v2/'
}



//////////////////
// WEBPACK FOOTER
// ./config/api.config.js
// module id = mrgY
// module chunks = 29